import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, DropdownButton } from "components/bootstrap";
import useSelectedEntities from "./hooks/useSelectedEntities";
const BulkActionsDropdown = ({ children = void 0, bsSize = "small" }) => {
  const { t } = useTranslation("common");
  const { selectedEntities, setSelectedEntities } = useSelectedEntities();
  const cancelEntitySelection = useCallback(() => setSelectedEntities([]), [setSelectedEntities]);
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      bsSize,
      title: t("bulk_actions.title"),
      id: "bulk-actions-dropdown",
      disabled: !(selectedEntities == null ? void 0 : selectedEntities.length)
    },
    children,
    Boolean(React.Children.count(children)) && /* @__PURE__ */ React.createElement(MenuItem, { divider: true }),
    /* @__PURE__ */ React.createElement(MenuItem, { onClick: cancelEntitySelection }, t("bulk_actions.cancel"))
  );
};
export default BulkActionsDropdown;
